<div class="capa-home">
  <div class="capa-home-titulo">
    <p>ERROR 500</p>
  </div>
  <div style="text-align: center; margin: 40px 0px">
    <h1 class="title_error">ERROR AL VALIDAR LAS CREDENCIALES DEL CLIENTE</h1>
    <br />
    <p class="h2">CLIENTE SIN PERMISOS DE ACCESO</p>
  </div>
</div>
